<!-- vscode-disable -->
<!-- prettier-ignore -->
<div class="keyboard" (touchstart)="onKeyboardBackgroundTap($event)">
  <!-- Handle bar is added by popover-host when in bottom sheet mode -->

  <!-- Top control bar -->
  <div class="control-bar">
    <!-- Fraction keys when fractions are allowed and no roller -->
    @if (opts.allowFractions && lane1.values.length === 0) {
      <div class="fraction-keys">
        <div class="fraction-key" (touchstart)="onKeyboardClick($event, KeyCode.Slash)">/</div>
        <div class="fraction-key space-key" (touchstart)="onKeyboardClick($event, KeyCode.Space)">⎵</div>
      </div>
    }

    <!-- View toggle (keyboard/roller) - show when roller available, unless
         this control offers the roller only (#4904) -->
    @if (lane1.values.length > 0 && !opts.rollerOnly) {
      <cs-segment [(selection)]="currentView">
        <cs-segment-button [value]="KeyboardView.Keyboard">
          <cs-icon name="keyboard-keys"></cs-icon>
        </cs-segment-button>
        <cs-segment-button [value]="KeyboardView.Roller">
          <cs-icon name="view-column-2"></cs-icon>
        </cs-segment-button>
      </cs-segment>
    }

    <!-- Placeholder for left side when no fractions or view toggle -->
    @if (!opts.allowFractions && (lane1.values.length === 0 || opts.rollerOnly)) {
      <div class="left-placeholder">
        <!-- Empty space to maintain layout -->
      </div>
    }

    <!-- Current value display - hide in dual roller mode as it's too cramped -->
    @if (!isDualRoller || currentView !== KeyboardView.Roller) {
      <div class="value-display" #valueDisplay
        [ngClass]="{'expanded': unitDisplayMode === UnitDisplayMode.None}">
        <span class="value-text" [ngClass]="{'selected': isValueSelected && currentView === KeyboardView.Keyboard}">{{
        displayValue }}</span>@if (currentView === KeyboardView.Keyboard && !isValueSelected) {
        <span class="cursor"
        ></span>
      }
    </div>
  }

  <!-- Serving button for custom unit configs -->
  @if (opts.isCustomUnitConfig && unitDisplayMode === UnitDisplayMode.Selector) {
    <cs-segment>
      <cs-segment-button (segmentClick)="onServingClick($event)">
        {{ unit1.label }}
        <cs-icon name="arrow-dropdown"></cs-icon>
      </cs-segment-button>
    </cs-segment>
  }
  <!-- Static unit display - show when alwaysShowUnit is true and there's only one unit -->
  @if (alwaysShowUnit && unitDisplayMode === UnitDisplayMode.None && !opts.isCustomUnitConfig) {
    <cs-segment>
      <cs-segment-button class="static-unit">
        {{ unit1.label }}
      </cs-segment-button>
    </cs-segment>
  }
  <!-- Unit toggle - show for 2 units -->
  @if (unitDisplayMode === UnitDisplayMode.Toggle && !opts.isCustomUnitConfig) {
    <cs-segment [(selection)]="currentUnit"
      >
      <cs-segment-button [value]="unit1.id">{{ unit1.label }}</cs-segment-button>
      @if (unit2) {
        <cs-segment-button [value]="unit2.id">{{ unit2.label }}</cs-segment-button>
      }
    </cs-segment>
  }
  <!-- Unit selector for 3+ units -->
  @if (unitDisplayMode === UnitDisplayMode.Selector && !opts.isCustomUnitConfig) {
    <cs-segment>
      <cs-segment-button (segmentClick)="onUnitSelectorClick($event)">
        {{ unit1.label }}
        <cs-icon name="arrow-dropdown"></cs-icon>
      </cs-segment-button>
    </cs-segment>
  }
  <!-- Placeholder when no unit toggle and not showing static unit -->
  @if (unitDisplayMode === UnitDisplayMode.None && !opts.isCustomUnitConfig && !alwaysShowUnit) {
    <div class="unit-toggle-placeholder"
      >
      <!-- Empty space to maintain layout -->
    </div>
  }
</div>

<!-- Number pad -->
@if (currentView === KeyboardView.Keyboard) {
  <div class="number-pad">
    <div class="row">
      <div class="key" (touchstart)="onKeyboardClick($event, KeyCode.Num1)">1</div>
      <div class="key" (touchstart)="onKeyboardClick($event, KeyCode.Num2)">2</div>
      <div class="key" (touchstart)="onKeyboardClick($event, KeyCode.Num3)">3</div>
    </div>
    <div class="row">
      <div class="key" (touchstart)="onKeyboardClick($event, KeyCode.Num4)">4</div>
      <div class="key" (touchstart)="onKeyboardClick($event, KeyCode.Num5)">5</div>
      <div class="key" (touchstart)="onKeyboardClick($event, KeyCode.Num6)">6</div>
    </div>
    <div class="row">
      <div class="key" (touchstart)="onKeyboardClick($event, KeyCode.Num7)">7</div>
      <div class="key" (touchstart)="onKeyboardClick($event, KeyCode.Num8)">8</div>
      <div class="key" (touchstart)="onKeyboardClick($event, KeyCode.Num9)">9</div>
    </div>
    <div class="row">
      <div class="key" (touchstart)="onKeyboardClick($event, KeyCode.NumDot)"
      [ngClass]="{disabled: !opts.allowDecimal}">{{ opts.decimalSeparator || '.' }}</div>
      <div class="key" (touchstart)="onKeyboardClick($event, KeyCode.Num0)">0</div>
      <div class="key" (touchstart)="onKeyboardClick($event, KeyCode.Backspace)">
        <cs-icon name="backspace"></cs-icon>
      </div>
    </div>
  </div>
}

<!-- Roller view -->
@if (currentView === KeyboardView.Roller) {
  <div class="roller-view">
    <!-- Single roller -->
    @if (!isDualRoller) {
      <!-- Labels above roller -->
      @if (lane1.label) {
        <div class="roller-labels">
          <div class="roller-label">{{ lane1.label }}</div>
        </div>
      }
      <!-- Roller container with fixed height -->
      <div class="roller-container">
        @for (instance of roller1Instances; track trackRollerInstance($index, instance)) {
          <cs-roller [dataProvider]="lane1.provider" [currentIndex]="lane1.currentIndex" (currentIndexChange)="setLaneIndex(lane1, $event)" [visibleItems]="5"
          [itemHeight]="30"></cs-roller>
        }
      </div>
    }
    <!-- Dual roller -->
    @if (isDualRoller) {
      <!-- Labels above rollers -->
      <div class="roller-labels dual">
        <div class="roller-label">{{ lane1.label }}</div>
        <div class="roller-label">{{ lane2.label }}</div>
      </div>
      <!-- Dual roller container -->
      <div class="roller-container dual">
        @for (instance of roller1Instances; track trackRollerInstance($index, instance)) {
          <cs-roller [dataProvider]="lane1.provider" [currentIndex]="lane1.currentIndex" (currentIndexChange)="setLaneIndex(lane1, $event)" [visibleItems]="5"
          [itemHeight]="30" [alignment]="'right'"></cs-roller>
        }
        @for (instance of roller2Instances; track trackRollerInstance($index, instance)) {
          <cs-roller [dataProvider]="lane2.provider" [currentIndex]="lane2.currentIndex" (currentIndexChange)="setLaneIndex(lane2, $event)" [visibleItems]="5"
          [itemHeight]="30" [alignment]="'left'"></cs-roller>
        }
      </div>
    }
  </div>
}

<!-- Accept button -->
<div class="action-buttons">
  <button class="log-btn" [class.disabled]="isConfirmButtonDisabled" [disabled]="isConfirmButtonDisabled"
    (touchstart)="!isConfirmButtonDisabled && onConfirmClick($event)">
    @if (confirmButtonLabel) {
      {{ confirmButtonLabel }}
    } @else {
      {{ LL.common.buttons.accept() }}
    }
  </button>
</div>
</div>